import { buildReducer, createMapOfSet } from '../../../../shared';
import {
    deletedContactsRetrieveCompletedAction,
    hardDeleteCompletedAction,
    restoreContactsCompletedAction,
} from '../../../../hub';
import type { DeletedPersonasState } from '../../../state/data/hubDataState';

const defaultLoadingState: DeletedPersonasState = {
    isError: false,
    isLoading: true,
    deletedPersonas: [],
    recoverablePersonas: [],
};

export default buildReducer<DeletedPersonasState>()
    .handleDataAction(
        deletedContactsRetrieveCompletedAction,
        (_state, action) => {
            return {
                isError: false,
                isLoading: false,
                deletedPersonas: action.payload.deletedItemsContacts,
                recoverablePersonas: action.payload.recoverableItemsContacts,
            };
        },
        (_state, action) => ({
            ...defaultLoadingState,
            isError: true,
            isLoading: false,
        })
    )
    .handleDataAction(hardDeleteCompletedAction, (state, action) => {
        const alreadyDeletedPersonas = createMapOfSet(
            action.payload.personas.map(persona => persona.hubPersonaId)
        );
        return {
            isError: false,
            isLoading: false,
            deletedPersonas: [
                ...state.deletedPersonas.filter(
                    persona => !alreadyDeletedPersonas[persona.hubPersonaId]
                ),
            ],
            recoverablePersonas: [
                ...state.recoverablePersonas.filter(
                    persona => !alreadyDeletedPersonas[persona.hubPersonaId]
                ),
            ],
        };
    })
    .handleDataAction(restoreContactsCompletedAction, (state, action) => {
        const alreadyDeletedPersonas = createMapOfSet(
            action.payload.personas.map(persona => persona.hubPersonaId)
        );
        return {
            isError: false,
            isLoading: false,
            deletedPersonas: [
                ...state.deletedPersonas.filter(
                    persona => !alreadyDeletedPersonas[persona.hubPersonaId]
                ),
            ],
            recoverablePersonas: [
                ...state.recoverablePersonas.filter(
                    persona => !alreadyDeletedPersonas[persona.hubPersonaId]
                ),
            ],
        };
    })
    .done(defaultLoadingState);
export type { Action } from '../../../../shared';
